import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IUtmData, IUtmStatistics, IUtmTracking, IUtmTrackings, IUtmTrackingsRequest, UtmTrackingsPage, UtmTrackingsPagedData } from './utmtrackings-model';

@Injectable()
export class UtmTrackingsService {
    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'utmtrackings';

    /** POST */
    public getUtmData(page: UtmTrackingsPage): Observable<SuccessResponse<UtmTrackingsPagedData<IUtmTracking>> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<UtmTrackingsPagedData<IUtmTracking>>>(
                UtmTrackingsService.URL +
                UtmTrackingsService.ENDPOINT +
                '/' + 'filters',
                page
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getUtmDataForStatistics(model: IUtmTrackingsRequest): Observable<SuccessResponse<IUtmStatistics> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<IUtmStatistics>>(
                UtmTrackingsService.URL +
                UtmTrackingsService.ENDPOINT +
                '/' + 'statistics',
                model
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getUtmDataForExport(model: IUtmTrackingsRequest): Observable<SuccessResponse<IUtmTrackings> | ErrorResponse>  {
        return this.http
            .post<SuccessResponse<IUtmTrackings>>(
                UtmTrackingsService.URL +
                UtmTrackingsService.ENDPOINT +
                '/' + 'exports',
                model
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }
}
